<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
              <video id="myVideo" loop muted data-autoplay>
                <source src="/videos/portage.mp4" type="video/mp4">
                <source src="/videos/portage.webm" type="video/webm">
              </video>
                </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Portage de repas à domicile
                </h1>
            </a></div>
        </full-page>



        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#808281;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">
                                          Une longue expérience
                                        </h2>
                                        <p>
                                          Le portage à domicile est un service que nous proposons depuis la création de notre entreprise il y a bientôt 10 ans, ce qui nous a permis d’acquérir un réel savoir-faire et ainsi proposer un service parfaitement adapté. Souscrire à un abonnement de livraison ce n’est pas seulement s’assurer une alimentation quotidienne, c’est aussi prendre soin de sa santé.
                                        </p>
                                      <h3 class="display-6">
                                        Les atouts du portage à domicile
                                      </h3>
                                      <p>
                                        Bénéficier du portage de repas à domicile, permet de diminuer les risques de dénutrition des personnes âgées qui peut entrainer chutes et maladies. Bien souvent, en vieillissant, l’appétit diminue, il est donc important de proposer chaque jour, des petits plats qui font envie. Bien manger est source de bien être et permet de garder le moral, c’est important !
                                      </p>
                                      <div class="btns-action sr-up-td3 text-primary">
                                        <a href="https://www.menuportage.fr/" target="_blank"
                                                     class="btn btn-normal btn-white spaceTop">
                                          <span class="text">Visitez notre site sur le portage à domicile</span>
                                          <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                                        </a>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('/img/portage/fourgonette-croustillance.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Livraison de repas à domicile</h3>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/tarifs-portage-domicile.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Tarifs & carte des portages</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4" style="background:#95c01e;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">A qui s’adresse-t-il ?</h3>
                                        <p>
                                          Nous nous adressons aux personnes âgées ou handicapées qui souhaitent rester à leur domicile et pour qui la préparation des repas n’est plus possible. Nous pouvons également livrer aux personnes actives qui n’ont pas le temps de cuisiner : quoi de mieux que de rentrer le soir et de n’avoir qu’à réchauffer un plat préparé dont la qualité gustative et les ingrédients sont garantis ?
                                        </p>
                                      <p>
                                        Que vous soyez à la retraite, en arrêt maladie, en situation de handicap ou encore nul en cuisine, ce programme est fait pour vous !
                                      </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#40474c;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Des plats de qualité</h3>
                                        <p>
                                          Chaque matin nos équipes préparent de notre laboratoire, des plats équilibrés et cuisinés. Nous élaborons chaque jour, des menus qui correspondent aux habitudes alimentaires des séniors et qui sont équilibrés et variés. Marc, notre cuisinier dédié au portage à domicile, a plus de 45 ans d’expérience en restauration. Issu de la restauration traditionnelle, il prépare des plats savoureux et familiaux avec des recettes dont il a le secret. Chaque plat est composé d’une viande ou d’un poisson, de légumes et de féculents. L’apport calorique et nutritionnel est respecté.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#709016">
                            <div class="item media text-white alignLeft">

                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Une équipe dédiée à la livraison</h3>
                                        <p>
                                          La livraison est effectuée par nos livreuses, salariées dans l’entreprise depuis plusieurs années. Souriantes et attentionnées, elles sont les interlocutrices privilégiées de nos clients. Le passage quotidien de nos livreuses à leur domicile leur apporte l’assurance qu’en cas de chute ou de problème, quelqu’un sera là pour alerter les secours si nécessaire. Elles ont en permanence avec elles, les numéros d’urgence pour pouvoir contacter la famille rapidement. Nous assurons là, une certaine veille sociale qui permet d’apporter sécurité et confort.
                                        </p>
                                      <p>
                                        Réelles personnes de confiance, nos livreuses se chargent au cas par cas, de déposer dans le réfrigérateur, les plats des personnes pour qui les déplacements sont difficiles ou à mobilité réduite. Un petit mot, un sourire, une attention, c’est important pour ceux qu’on voit chaque jour et fait partie de notre accompagnement.
                                      </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              <div class="media-row">
                <div class="row backgroundGreen">
                  <div class="col-12 col-md-4 col-lg-4"
                       style="background-image: url('/img/portage/prepa-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <div class="item media text-white alignLeft">
                      <div class="media-img">
                        <div class="mask"></div>
                        <img class="img-block" src="/img/portage/prepa-repas.jpg" alt="Préparation des repas à livrer"
                             style="display: none;">
                        <div class="img"
                             style="background-image: url('/img/portage/prepa-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-8 col-lg-8" style="background:#4d3f74;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-5 bottomH2">La mise en place du service : temporaire ou permanent</h3>
                          <p>
                            La mise en place du portage est simple : il suffit de s’inscrire 48h00 à l’avance. Vous pouvez choisir la fréquence de livraison de 1 à 7 jours par semaine, du lundi au dimanche (la livraison des plats du dimanche, s’effectue le samedi).
                          </p>
                          <p>
                            Vous pouvez vous inscrire de manière temporaire ou durable : vous sortez d’hospitalisation et vous n’avez pas la possibilité de vous déplacer pendant quelques semaines ? Le portage de repas à domicile peut vous être proposé pendant toute cette période.
                          </p>
                          <p>
                            Votre conjoint(e) qui prend habituellement en charge la cuisine à la maison est absent pour quelques jours ou quelques semaines : nous pouvons vous proposer des repas en attendant sereinement sont retour. De plus, ce service vous permettra de vous dégager du temps si vous devez par exemple, lui rendre visite à l’hôpital, ce service vous donnera plus de liberté.
                          </p>
                          <p>
                            Enfin, si vous sentez que vos parents ou grands-parents n’arrivent plus à assumer cette charge au quotidien, nous pouvons leur proposer un service permanent. Celui-ci peut-être mis en place de façon graduelle : quelques jours par semaine pour garder de l’autonomie et le plaisir de cuisiner quelques jours
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="media-row">
                <div class="row backgroundGreen">
                  <div class="col-12 col-md-8 col-lg-8" style="background:#bb8c46;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-5 bottomH2">Les différentes formules</h3>
                          <p>
                            Nous proposons plusieurs formules afin de s’adapter aux besoins et aux habitudes de chacun : le menu complet : entrée + plat + dessert auquel peut-être ajouté le fromage, le pain, une soupe. Selon vos besoins, nous pouvons adapter la formule à la carte : entrée + plat ou plat + dessert, plat unique etc. Les combinaisons sont multiples et surtout peuvent évoluer dans les temps et s’adapter à l’évolution de l’appétit du bénéficiaire. Nous nous adaptons aussi aux saisons : nous servons plus de soupes en hiver qu’en plein été ! A vous de choisir la formule de votre choix.
                          </p>
                          <p>
                            Nous pouvons adapter les commandes en fonctions de certaines situations spécifiques de régime en proposant du haché, du mouliné ou du sans chou.
                          </p>
                          <p>
                            Nous livrons tous les matins du lundi au samedi. Le plat du dimanche est livré le samedi. La livraison est effectuée le matin, toujours à la même heure.
                          </p>
                          <p>
                            Vous pouvez annuler simplement une livraison, il suffit de nous prévenir 48h00 à l’avance. Un numéro de téléphone est dédié aux commandes et aux annulations.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4"
                       style="background-image: url('/img/portage/options-repas-portage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <div class="item media text-white alignLeft">
                      <div class="media-img">
                        <div class="mask"></div>
                        <img class="img-block" src="/img/portage/options-repas-portage.jpg" alt="Rotissoire à cochon"
                             style="display: none;">
                        <div class="img"
                             style="background-image: url('/img/portage/options-repas-portage.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="media-row">
                <div class="row backgroundGreen">
                  <div class="col-12 col-md-4 col-lg-4" style="background:#645657;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-6">
                            Zone géographique desservie
                          </h3>
                          <p>
                            Nous livrons de Chavelot à Charmes en passant par tous les villages situés de part et d’autre de cette zone : Frizon, Igney, Vaxoncourt, Girmont, Pallegney, Domèvre-sur-Durbion, Hadigny-les-Verrières, Moriville, Vincey, Langley, Essegney, Chamagne, Socourt, Portieux, la Verrerie de Portieux, Nomexy, Chatel-sur-Moselle.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4"
                       style="background-image: url('/img/portage/zone-portage-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <div class="item media text-white alignLeft">
                      <div class="media-img">
                        <div class="mask"></div>
                        <img class="img-block" src="/img/portage/zone-portage-repas.jpg'" alt="An image"
                             style="display: none;">
                        <div class="img"
                             style="background-image: url('/img/portage/zone-portage-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                      </div>
                      <div class="media-body align-top">
                        <div class="desc">

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4"
                       style="background-color:#888853;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-6">
                            La facturation
                          </h3>
                          <p>
                            La facturation est effectuée chaque fin de mois. La facture peut être remise en main propre ou envoyée par mail ou par courrier au destinataire de votre choix.
                          </p>
                          <p>
                            Plusieurs solutions de paiement : par chèque, par virement ou en espèces. L’ensemble des paiements peuvent être remis à nos livreuses en qui nous avons toute confiance.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="media-row">
                <div class="row backgroundGreen">
                  <div class="col-12 col-md-4 col-lg-4"  style="background:#502139;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-6">Les prises en charge</h3>
                          <p>
                            Une prise en charge du portage à domicile est parfois possible si vous en faite la demande auprès de votre complémentaire santé. D’autres aides sont possibles sous réserve de conditions de revenus. Vous pouvez obtenir les informations auprès des assistantes sociales du Conseil Départemental. Nous pouvons vous établir un devis pour pouvoir entamer une demande de prise en charge.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4"  style="background:#555f6a;">
                    <div class="item media text-white alignLeft">
                      <div class="media-body align-top">
                        <div class="desc">
                          <h3 class="display-6">La mise en place du portage à domicile</h3>
                          <p>
                            Pour s’inscrire il suffit de nous contacter Frédéric par téléphone au 06 37 08 20 41
                            ou Julie par mail <a href="mailto:julie@croustillance.fr">julie@croustillance.fr</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4"
                       style="background-image: url('/img/portage/preparation-livraison.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <div class="item media text-white alignLeft">
                      <div class="media-img">
                        <div class="mask"></div>
                        <img class="img-block" src="/img/portage/preparation-livraison.jpg" alt="An image"
                             style="display: none;">
                        <div class="img"
                             style="background-image: url('/img/portage/preparation-livraison.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                      </div>
                      <div class="media-body align-top">
                        <div class="desc">

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
        </div>




      <div class="">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-12 col-lg-12" style="background:#b7226e;">
            <div class="text-white alignLeft">
              <div class="align-top">
                <div class="desc">
                  <h3 class="display-5" style="padding:20px;">Une équipe entièrement dédiée</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="media-row">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-8 col-lg-8" style="background:rgb(119, 125, 123);">
            <div class="item media text-white alignLeft">
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Catherine</h3>
                  <p>Catherine travaille au service de portage à domicile depuis plus de cinq ans. Les petites routes et les villages des environs n’ont plus aucun secret pour elle ! Et c’est par tous les temps qu’elle va servir ses clients : pluie, neige, verglas, rien ne l’empêchera de passer pour aller porter les repas.</p>
                  <p>La disponibilité et le sourire de Catherine sont de véritables soutiens pour les personnes âgées qu’elle rencontre quotidiennement à leur domicile. Son passage permet de rompre l’isolement et d’assurer une véritable veille sociale. Catherine peut, si c’est nécessaire, donner l’alerte auprès de la famille ou des services de santé.</p>
                  <p>Avec elle, tout va bien !</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('/img/portage/catherine.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
                <div class="mask"></div>
                <img class="img-block" src="/img/portage/catherine.jpg'" alt="Catherine, livreuse de repas à domicile"
                     style="display: none;">
                <div class="img"
                     style="background-image: url('/img/portage/catherine.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="media-row">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('/img/portage/Sabrina-DENET.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
                <div class="mask"></div>
                <img class="img-block" src="/img/portage/Sabrina-DENET.jpg" alt="Catherine, livreuse de repas à domicile"
                     style="display: none;">
                <div class="img"
                     style="background-image: url('/img/portage/Sabrina-DENET.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 col-lg-8" style="background:rgb(153, 165, 165);">
            <div class="item media text-white alignLeft">
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Sabrina</h3>
                <p>Sabrina travaille depuis plusieurs années au portage de repas à domicile. Sur la route du lundi au samedi, elle transporte ses repas de Charmes à Chavelot en faisant des petits crochets partout où ses clients l’attendent…</p>
                <p>Affichant une indéfectible bonne humeur, elle a toujours le sourire et en fait profiter son entourage, ce qui lui permet d’aborder chaleureusement chaque client de sa tournée. Calme et rassurante, Sabrina sait répondre aux questions de chacun : quels plats, quelle cuisson et même quelle est la fête du jour ! Car tout au long de sa tournée, cette généreuse vosgienne s’adapte au rythme de chacun pour répondre à leurs attentes et prend plus de temps pour ceux qui en ont besoin.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="media-row">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-8 col-lg-8" style="background:rgb(119, 125, 123);">
            <div class="item media text-white alignLeft">
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Sabrina</h3>
                  <p>Ce n’est pas une mais deux Sabrina qui prennent soin des clients à leur domicile ! Arrivée plus récemment, la jeune Sabrina est venue compléter l’équipe, où elle apporte son dynamisme et sa bonne humeur. </p>
                <p>Très proche de ses clients, Sabrina s’implique complètement dans sa mission. Depuis bientôt un an, elle se rend disponible pour effectuer quotidiennement le portage de repas à domicile en complément de ses deux collègues. Très respectueuse des personnes âgées, Sabrina s’investit complètement dans son rôle et a su rapidement être proche de ses clients. Très rigoureuse dans sa mission, elle connait chacun d’entre eux et sait répondre au mieux à leurs besoins. Organisée et ponctuelle, Sabrina sera toujours à l’heure au rendez-vous du portage à votre domicile.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('/img/portage/Sabrina-DEGHAL.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
                <div class="mask"></div>
                <img class="img-block" src="/img/portage/Sabrina-DEGHAL.jpg'" alt="Catherine, livreuse de repas à domicile"
                     style="display: none;">
                <div class="img"
                     style="background-image: url('/img/portage/Sabrina-DEGHAL.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="media-row">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('/img/portage/marc-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
                <div class="mask"></div>
                <img class="img-block" src="/img/portage/marc-cuisinier.jpg" alt="Catherine, livreuse de repas à domicile"
                     style="display: none;">
                <div class="img"
                     style="background-image: url('/img/portage/marc-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 col-lg-8" style="background:rgb(153, 165, 165);">
            <div class="item media text-white alignLeft">
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Marc</h3>
            <p>Cuisinier depuis plus de quarante ans, Marc assure la préparation de l’ensemble des plats pour nos clients du portage à domicile. De l’entrée au dessert, Marc cuisine des mets simples et savoureux adaptés aux goûts de la clientèle : plats en sauce, légumes bien cuits, produits de saison. Marc propose un maximum de produits frais dès que c’est possible : c’est lui qui détient le record de rapidité d’épluchage de la cuisine !</p>
                  <p>L’ensemble des plats qu’il cuisine sont conçus pour pouvoir être réchauffés par les clients sans se dessécher.</p>
                  <p>Méthodique et organisé, Marc applique rigoureusement les règles d’hygiène et de sécurité en vigueur.</p>
                  <p>Marc est le cuisinier en charge de la réalisation de tous les plats du portage à domicile, il possède une expérience en cuisine de 40 ans en restaurant et en cuisine collective. Originaire de la Région Grand Est, il maîtrise toutes les recettes de notre terroir. Sa nature généreuse se retrouve dans sa cuisine familiale et gourmande !</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <footer-page></footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'portage',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Croustillance vous livre à domicile des repas savoureux et équilibrés, dans la région de Charmes et de Châtel-sur-Moselle. Service de portage sans abonnement.";
            document.title = "Service de portage de repas à domicile";
        }
    }
</script>

<style>
    .bottomH2 {
        margin-bottom: 25px;
    }

    #portage {
        background: url('/img/portage/livraison-repas-domicile.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>